import { ChevronRight } from "@mui/icons-material";
import { Box, Button, ButtonProps, LinkTypeMap, Link as MuiLink, Slide, Stack, Typography, useTheme } from "@mui/material";
import { CrossDomainLink } from '@seeka-labs/converge-react';
import isAbsoluteUrl from 'is-absolute-url';
import React, { ElementType, useMemo } from "react";
import { ContentfulAsset, ContentfulAssetImage } from "../ui";

export type LinkPropsBase = {
    url: string | undefined | null
    label?: string | undefined | null
    mobileLabel?: string | undefined | null
    description?: string | undefined | null
    relativeLinkComponent?: ElementType;
    forceLink?: boolean;
    LinkProps?: LinkTypeMap['props']
    endIcon?: React.ReactNode
    startIcon?: React.ReactNode
    dropdownItemIcon?: ContentfulAsset
}

export type LinkProps = Omit<ButtonProps, 'href'> & LinkPropsBase

type LinkLabelAndDescriptionProps = {
    label: string | undefined | null,
    description: string | undefined | null,
    mobileLabel?: string | undefined | null,
    onClick?: () => void
    icon?: ContentfulAsset
    transitionIndex?: number
}

export function LinkLabelAndDescription({ label, description, onClick, mobileLabel, icon, transitionIndex }: LinkLabelAndDescriptionProps) {
    const theme = useTheme();

    const labelText = useMemo(() => {
        if (!mobileLabel) return label;

        return <><Box component={"span"} sx={{ display: { xs: 'none', sm: 'none', md: 'inherit' } }}>{label}</Box><Box component={"span"} sx={{ display: { xs: 'inherit', sm: 'inherit', md: 'none' } }}>{mobileLabel}</Box></>
    }, [])

    // let comp: React.JSX.Element;
    if (!description && !icon) {
        if (!onClick) {
            return labelText;
        }
        // else {
        //     return <Stack gap={2} direction="row" onClick={onClick} alignItems="center" justifyContent="space-between">
        //         <Typography variant="h4" component={"div"} sx={{ fontSize: theme.typography.h5.fontSize }} gutterBottom={false}>{labelText}</Typography>
        //         <ChevronRight />
        //     </Stack>
        // }
    }

    const comp = <Stack gap={2} direction="row" alignItems="center" justifyContent="space-between">
        {icon ? <Box><ContentfulAssetImage asset={icon} imgStyle={{ height: description ? '60px' : 'auto', width: '60px' }} /></Box> : null}
        <Stack sx={{ width: '100%' }} gap={0.5} alignItems={'flex-start'} justifyContent={'flex-start'}>
            <Typography variant="h4" component={"div"} sx={{ fontSize: theme.typography.h5.fontSize, color: 'inherit' }} gutterBottom={false}>{labelText}</Typography>
            {description && <Typography variant="body1">{description}</Typography>}
        </Stack>
        <ChevronRight />
    </Stack>

    return (
        <Box sx={{ maxWidth: '400px', color: theme.palette.text.primary, ':hover': { color: theme.palette.primary.main } }} onClick={onClick}>
            {transitionIndex != undefined ? (
                <Slide timeout={200 + (transitionIndex * 200)} in={true} direction="right">
                    {comp}
                </Slide>
            ) : comp}
        </Box>
    )
}

export const onLinkClick = (url: string, e: React.MouseEvent, onClick: (e: React.MouseEvent) => void) => {
    const isCookieConsentButton = url === '#consent-settings';
    const isContactUsButton = url === '#contact-us';

    // console.log('heree isContactUsButton', isContactUsButton, url)

    if (isCookieConsentButton) {
        try {
            (window as any).OneTrust?.ToggleInfoDisplay()
        }
        catch (e) {
            console.error(e)
        }

    }
    if (isContactUsButton) {
        try {
            // if((window as any).)
            if ((window as any).showIntercomChat) (window as any).showIntercomChat();
            else document.getElementById('chat-icon-overlay').click();

            // (window as any).tryOpen();
            // (window as any).showIntercomChat();
            setTimeout(() => {
                (window as any).tryOpen('showNewMessage');
            }, 500)
        }
        catch (e) {
            console.error(e)
        }
    }
    if (onClick) {
        onClick(e as any)
    }
}

export function Link({ url, label, description, mobileLabel, relativeLinkComponent, forceLink, LinkProps, endIcon, startIcon, children, ...other }: LinkProps) {
    const isAbsUrl = url && isAbsoluteUrl(url)

    // console.log('heree relative', label, relativeLinkComponent)

    const onClick = (e: React.MouseEvent) => {
        onLinkClick(url || '', e, other.onClick as any)
    }

    if (forceLink) {
        return relativeLinkComponent && !isAbsUrl ?
            <MuiLink underline='none' component={relativeLinkComponent} color="inherit" href={url || undefined} to={url || undefined} {...other as any} onClick={onClick} sx={{ fontSize: 'inherit', ...other.sx, ...LinkProps?.sx }} {...LinkProps}>
                {children ? children : <LinkLabelAndDescription label={label} description={description} mobileLabel={mobileLabel} />}
            </MuiLink>
            :
            <CrossDomainLink>
                <MuiLink underline='none' color="inherit" href={url || undefined} {...isAbsUrl ? { target: '_blank' } : undefined} to={url || undefined} {...other as any} onClick={onClick} sx={{ fontSize: 'inherit', ...other.sx, ...LinkProps?.sx }} {...LinkProps}>
                    {children ? children : <LinkLabelAndDescription label={label} description={description} mobileLabel={mobileLabel} />}
                </MuiLink></CrossDomainLink>
    }
    else {

        return relativeLinkComponent && !isAbsUrl ?
            <Button component={relativeLinkComponent} variant="text" color="inherit" href={url || undefined} to={url || undefined} {...other} onClick={onClick} sx={{ fontSize: 'inherit', ...other.sx }} endIcon={endIcon} startIcon={startIcon}>
                <LinkLabelAndDescription label={label} description={description} mobileLabel={mobileLabel} />
            </Button>
            :
            <CrossDomainLink>
                <Button variant="text" color="inherit" href={url || undefined} {...isAbsUrl ? { target: '_blank' } : undefined} {...other} onClick={onClick} sx={{ fontSize: 'inherit', ...other.sx }} endIcon={endIcon} startIcon={startIcon}>
                    {children ? children : <LinkLabelAndDescription label={label} description={description} mobileLabel={mobileLabel} />}
                </Button>
            </CrossDomainLink>
    }
}